"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rating = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../../hooks/internal");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Rating = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentProduct: {
      ratingAverage,
      ratingCount
    }
  } = (0, _internal.useProduct)();
  const {
    isRatingsAndReviewsEnabled
  } = (0, _internal.useSharedConfiguration)();
  if (!isRatingsAndReviewsEnabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.StarRating, {
    showVotes: true,
    "data-testid": getTestId(_constants.RATING),
    max: 5,
    value: ratingAverage,
    votes: ratingCount,
    showTextRating: false
  });
};
exports.Rating = Rating;
